import * as React from 'react'
import { useRef } from 'react';
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Container, ListGroup, ListGroupItem, ListGroupItemHeading, Row, Col,
    Form, FormGroup, Label,Alert,
    Input, Button, Spinner, Badge, Modal, ModalHeader, ModalBody, ModalFooter, } from 'reactstrap';
import { 
    UpdateUserProfile as UpdateUserProfileAction, 
    verified as verifiedAction, 
    fetchUserRequest as getUserAction } from '../../store/user/UserActions';
import { getDiscountRequest as getDiscountRequestAction} from '../../store/cart/actions'
import { IUser, IOrder } from '../../store/interface'
import '@fortawesome/fontawesome-free/css/all.css';
import Select from 'react-select';
import { GeneralUtil } from '../../utils/generalUtil';
import { createRequest as createRequestAction } from '../../store/orders/actions';
import { store } from 'react-notifications-component';
import { Redirect } from 'react-router-dom';
// @ts-ignore
import randomstring from "randomstring";
import queryString from 'query-string'

const generalUtil: GeneralUtil = new GeneralUtil();

const _addrSelection : any = [
    { label: "Home Address", value: "Home" },
    { label: "Company Address", value: "Company" }
];

let removeFlag = false;

interface PropsFromState {
    route: any
    userRd : IUser
    user: IUser
    cart : any
}

interface IState {
    [key: string]: any
    modalGetDiscount : boolean
    discountCourseId : string
    discountCoursePrice : number
    discountCode : string
    pmtPaymentID :string
    pmtOrderNumber: string
    pmtCCNo : string
    pmtFxCode : string
    pmtHashValue : string
    pmtClientIPAdd : string
    modalPaymentProcessingPopupState : boolean
    modalPaymentProcessingMessage: string
    modalPaymentResultPopupState : boolean
    modalPaymentResultMessage : string
    redirect: boolean
}

interface PropsFromDispatch {
    fetchUserRequest : typeof getUserAction
    UpdateUserProfile: typeof UpdateUserProfileAction
    verified: typeof verifiedAction
    createRequest : typeof createRequestAction
    getDiscountRequest : typeof getDiscountRequestAction
}

type AllProps = PropsFromState & PropsFromDispatch

class ShopingCart extends React.Component<AllProps, IState> {
    myFormRef:any;
    constructor(props: AllProps) {
        super(props);

        // To handle for First load use "this.props.user?.cart", else use "this.props.userRd?.cart"
        let cart = (this.props.userRd?.cart == null || this.props.userRd?.cart == undefined) ? this.props.user?.cart : this.props.userRd?.cart

        this.state = {
            modalGetDiscount : false,
            discountCourseId : '',
            discountCoursePrice : 0,
            discountCode:'',
            cartItems: cart,
            cartItemsByOrganiser : {},
            addrType: _addrSelection[0],
            billingName: this.props.user?.fullName,
            billingAddr: this.props.user?.permanentAdd,
            billingPhoneNo: this.props.user?.contactNo,
            billingEmail: this.props.user?.emailAdd,
            paymentMethod: cart?.pmtInfo?.pmtMethod,
            paymentStatus: cart?.pmtInfo?.pmtStatus,
            pmtPaymentID : '',
            pmtOrderNumber : cart?.orderNo,
            pmtHashValue : '',
            pmtClientIPAdd : '',
            pmtCCNo : '',
            pmtFxCode : '',
            modalPaymentProcessingPopupState: false,
            modalPaymentProcessingMessage : '',
            modalPaymentResultPopupState : false,
            modalPaymentResultMessage : '',
            redirect: false,
        };

        //console.log(cart);

        // console.log("User Reducer");
        // console.log(this.props.userRd?.cart);
        // console.log("User Info");
        // console.log(this.props.user?.cart);

        this.myFormRef = React.createRef();

        this.handleRemoveFromCart = this.handleRemoveFromCart.bind(this);
        this.handleInputOnChange = this.handleInputOnChange.bind(this);
        //this.handlePaymentClick = this.handlePaymentClick.bind(this);
        this.handlePaymentSubmit = this.handlePaymentSubmit.bind(this);
        this.handleSelectOnChange = this.handleSelectOnChange.bind(this);
        
        this.handleDiscountClick = this.handleDiscountClick.bind(this);
        this.handleGetDiscountPopup = this.handleGetDiscountPopup.bind(this);
        this.handleDiscountChange = this.handleDiscountChange.bind(this);
        this.handleDiscount = this.handleDiscount.bind(this);
        this.handleModalPaymentResultMessage = this.handleModalPaymentResultMessage.bind(this);
        // _addrSelection.push({ value: this.props?.user.permanentAdd, label: this.props?.user.permanentAdd });
        // _addrSelection.push({ value: this.props?.user.compAdd, label: this.props?.user.compAdd });
    }

    public componentDidMount() {
        const parsed = queryString.parse(this.props.route.location.search);

        if (parsed.pmtStatus){
            if (parsed.pmtStatus === "failed"){
                this.setState({
                    modalPaymentResultPopupState : !this.state.modalPaymentResultPopupState,
                    modalPaymentResultMessage : parsed.pmtErrMsg.toString() });
            }
        }

        const { fetchUserRequest: fr, user } = this.props
        fr();
    }

    
    componentDidUpdate(prevProps: AllProps) {
        //console.log({ "prevProps": prevProps, "this.props": this.props });
        
        if ((prevProps.user._etag != this.props.user._etag) || (prevProps.user.processState != this.props.user.processState) ){
            if (this.props.user.processState === 1){  // Update success
                if (removeFlag) {
                    removeFlag = false;
                    store.addNotification({
                        title: "Info",
                        message: "Remove course successfully",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            showIcon: true
                        }
                    });
                }
                else {
                    store.addNotification({
                        title: "Info",
                        message: "Save successfully",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            showIcon: true
                        }
                    });
                }
            }
        }

        if (prevProps.cart.processState === 0 && this.props.cart.processState === 1){
            var discountedData = this.props.cart.data;
            // console.log("Discount Course Id : " + this.state.discountCourseId);
            // console.log("Discounted Price : " + discountedPrice);
            //console.log("!!!!!!!!!!!!!!!!!");
            //console.log(discountedData);
            let subTotal = 0;
            let taxAmt = 0;
            let _courseId = this.state.discountCourseId;

            this.state.cartItems.items.filter((d:any) => {
                return d.courseId === _courseId;   
                }).map((obj:any, idx:any) => {
                   if (discountedData.discPrice != undefined && discountedData.discPrice >= 0){
                        obj.priceType = discountedData.discType;
                        obj.discountCode = this.state.discountCode;
                        obj.price = Number(discountedData.discPrice);
                        obj.promoRuleLimitUse = discountedData.ruleLimitUse;
                        obj.promoRuleSingleUserPerUser = discountedData.singleUserPerUser;
                   } else{
                        store.addNotification({
                            title: "Alert!",
                            message: "Invalid discount",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 3000,
                                showIcon: true
                            }
                        });
                   }
                   return obj;
              });
    
            // let _items = this.state.cartItems.items.filter((i: any) => {
            //     return (i.courseId).toString() !== _courseId;
            // });

            var ciByOrganiser = this.state.cartItems?.items?.reduce(function (r:any, a:any) {
                r[a.organisersName] = r[a.organisersName] || [];
                r[a.organisersName].push(a);
                return r;
            }, Object.create(null));
            this.setState({ cartItemsByOrganiser: ciByOrganiser }); 
            console.log("===>ciByOrganiser");
            console.log(ciByOrganiser);
    
            this.state.cartItems.items.forEach((element: any, index: number) => {
                element.id = index + 1;
                subTotal += Number(element.price);
            });
            taxAmt = (subTotal / 100) * 0;
    
            let _cartItems: any = {
                items: this.state.cartItems.items,
                subTot: Number(subTotal.toFixed(2)),
                tax : Number(taxAmt.toFixed(2)),
                totAmt : Number((subTotal + taxAmt).toFixed(2)),
                billingInfo : this.state.cartItems.billingInfo,
                pmtInfo : this.state.cartItems.pmtInfo
            }
    
            this.setState({
                cartItems: _cartItems
            }, () => {
                this.props.UpdateUserProfile({
                    cart: this.state.cartItems
                });
            });
        }
    }

    public GetImagePath(fileName: string){
        fileName = fileName.replace("/courses/","").replace("courses/","").replace(".jpg","_md.jpg");
        return "https://images.ultimatespro.com/images/" + fileName;
    }

    constructCPDPoint(array: any) {
        let data: any = [];

        array.forEach((element: any) => {
            //data.push(element.profession + " (" + element.points + ")");
            data.push(element.profession + " (" + element.cpdRefNo + ")");
            // data.push("Engineer: 123");
        });

        return data.join(", ");
    }

    fixedNumberLen(n: any, len: any) {
        let num: any = parseInt(n, 10);
        len = parseInt(len, 10);
        if (isNaN(num) || isNaN(len)) {
            return n;
        }
        num = '' + num;
        while (num.length < len) {
            num = '0' + num;
        }
        return num;
    }

    handleSelectedOption = (optionList: any, name: string) => {
        let arr: any = [];

        if (optionList && name) {
            let index = optionList.map(function(e: any) { 
                return e.value; 
            }).indexOf(name);
    
            if (index !== -1) {
                arr.push(optionList[index]);
            }
        }

        return arr;
    }

    handleRemoveFromCart = (event: any) => {
        event.preventDefault();

        if (window.confirm("Are you sure want to remove this course?")) {
            removeFlag = true;
            let subTotal = 0;
            let taxAmt = 0;
            let _courseId = event.target.id;
    
            let _items = this.state.cartItems.items.filter((i: any) => {
                return (i.courseId).toString() !== _courseId;
            });

            var ciByOrganiser = this.state.cartItems?.items?.reduce(function (r:any, a:any) {
                r[a.organisersName] = r[a.organisersName] || [];
                r[a.organisersName].push(a);
                return r;
            }, Object.create(null));
            this.setState({ cartItemsByOrganiser: ciByOrganiser }); 
    
            _items.forEach((element: any, index: number) => {
                element.id = index + 1;
                subTotal += Number(element.price);
            });
            taxAmt = (subTotal / 100) * 0;
    
            let _cartItems: any = {
                items: _items,
                subTot: Number(subTotal.toFixed(2)),
                tax : Number(taxAmt.toFixed(2)),
                totAmt : Number((subTotal + taxAmt).toFixed(2)),
                billingInfo : this.state.cartItems.billingInfo,
                pmtInfo : this.state.cartItems.pmtInfo
            }
    
            this.setState({
                cartItems: _cartItems
            }, () => {
                this.props.UpdateUserProfile({
                    cart: this.state.cartItems
                });
            });
        }
    }

    // handleDiscountChange = (event: any, index:number) => {
    //     let _targetValue = event.target.value;

    //     this.setState({
    //         discountList: _targetValue
    //     });
    // }

    handleInputOnChange = (event: any) => {
        let _targetName = event.target.name;
        let _targetValue = event.target.value;

        this.setState({
            [_targetName]: _targetValue
        });
    }

    handleSelectOnChange = (event: any) => {
        this.setState({
            addrType: event,
            billingAddr: (event.value === "Home") ? this.props.user?.permanentAdd : this.props.user?.compName + '\n' + this.props.user?.compAdd,
            billingPhoneNo: (event.value === "Home") ? this.props.user?.contactNo : this.props.user?.compContactNo,
        })
    }

    handlePaymentSubmit = async (event: any) => {
        event.preventDefault();

        //=========================================================
        // Validation
        //=========================================================
        // Check if cart contains different currency
        let isValidate = true;
                
        let currencyList: any = [];
        this.state.cartItems.items.forEach((element: any, index: number) => {
            let foundIndex = currencyList.map(function(e: any) { 
                return e.value; 
            }).indexOf(element.currency);
            //console.log(element.currency);
            if (foundIndex == -1) {
                currencyList.push(element.currency);
            }
        });

        if (currencyList.length > 1)
        {
            isValidate = false;
        } 
        
        if (!isValidate){
            store.addNotification({
                title: "Failed",
                message: "Cart containing courses for multiple currency. Please process payment for one course currency at a time.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 3000,
                    showIcon: true
                }
            });
            return;
        }

        if (this.state.cartItems?.totAmt == 0){
            // Zero Amount Don't redirect to payment
            console.log("FOC cart");
            console.log(this.state.cartItems.items[0]);
            console.log(this.state.cartItems.items.length);
            if (this.state.cartItems.items.length > 0){
                // Todo
                 console.log("FOC cart items");
                // Redirect to Payment Gateway
                await this.setState({modalPaymentProcessingPopupState : true, modalPaymentProcessingMessage : ''});

                // if Cart Order Number is Empty Generate New One
                if (this.state.pmtOrderNumber ==='' || this.state.pmtOrderNumber === undefined){
                    let getLatestPmtNumber = await generalUtil.GetLatestPmtNumber();
                    let newPmtNo = 'P' + this.fixedNumberLen(getLatestPmtNumber.latestPmtNo, 5);
                    await this.setState({pmtOrderNumber : newPmtNo});
                }else{
                    //console.log("Existing Order Number : " + this.state.pmtOrderNumber);
                }
                await this.setState({modalPaymentProcessingMessage : 'Payment Number:'+this.state.pmtOrderNumber});

                // Generate Unique Payment ID
                let paymentID = randomstring.generate({
                    length: 10,
                    charset: 'alphanumeric',
                    capitalization: 'uppercase'
                });
                await this.setState({
                    pmtPaymentID : this.state.pmtOrderNumber + "" + paymentID, 
                    modalPaymentProcessingMessage : 'Payment ID:'+paymentID,
                    pmtCCNo : "",
                    pmtFxCode : this.state.cartItems.items[0].currency // Get the first line currency code
                });

                let dataToProcess : any= {};
                dataToProcess.pmtID = this.state.pmtPaymentID;
                dataToProcess.orderNo = this.state.pmtOrderNumber;
                dataToProcess.amt = this.state.cartItems?.totAmt.toFixed(2);
                dataToProcess.fxCode = this.state.pmtFxCode;
                dataToProcess.ccNo = this.state.pmtCCNo;

                var userCart = {...this.state.cartItems}
                userCart.orderNo = this.state.pmtOrderNumber;   // order number is actually payment number
                userCart.pmtInfo = {
                    pmtMethod: this.state.paymentMethod,
                    pmtStatus: "Processing"
                };
                userCart.billingInfo= {
                    name: this.state.billingName,
                    address: this.state.billingAddr,
                    phoneNo: this.state.billingPhoneNo,
                    email: this.state.billingEmail,
                }

                dataToProcess.userCart = userCart;
                
                await this.setState({modalPaymentProcessingMessage : 'Preparing payment'});
                let pmtResponseData = await generalUtil.PrePaymentProcess(dataToProcess);
                if (pmtResponseData.isSuccess){
                    await this.setState({ 
                        pmtClientIPAdd : pmtResponseData.IPAddress,
                        pmtHashValue : pmtResponseData.hashedValue,
                        modalPaymentProcessingMessage : 'IP:'+pmtResponseData.IPAddress
                    });
                    
                    // Direct mark as order complete
                     let orderDataToProcess : any= {};
                    orderDataToProcess.orderNo = userCart.orderNo;

                    let orderResponseData = await generalUtil.OrderRequest(orderDataToProcess);
                    if (orderResponseData.isSuccess){

                        store.addNotification({
                            title: "Info",
                            message: "Successfully process order!!",
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 3000,
                                showIcon: true
                            }
                        });
                        await this.setState({modalPaymentProcessingMessage : 'Redirecting to My Course...'});
                        //return <Redirect to="/mycourses" />
                        this.setState({redirect : true });
                    }
                    else{
                        store.addNotification({
                            title: "Info",
                            message: "Failed to process order!!",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 3000,
                                showIcon: true
                            }
                        });
                        
                    }
                    
                } else {
                    store.addNotification({
                        title: "Info",
                        message: "Failed to process payment!",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 3000,
                            showIcon: true
                        }
                    });
                }
            }

        } else {
            // Redirect to Payment Gateway
            await this.setState({modalPaymentProcessingPopupState : true, modalPaymentProcessingMessage : ''});

            // if Cart Order Number is Empty Generate New One
            if (this.state.pmtOrderNumber ==='' || this.state.pmtOrderNumber === undefined){
                let getLatestPmtNumber = await generalUtil.GetLatestPmtNumber();
                let newPmtNo = 'P' + this.fixedNumberLen(getLatestPmtNumber.latestPmtNo, 5);
                await this.setState({pmtOrderNumber : newPmtNo});
            }else{
                //console.log("Existing Order Number : " + this.state.pmtOrderNumber);
            }
            await this.setState({modalPaymentProcessingMessage : 'Payment Number:'+this.state.pmtOrderNumber});

            // Generate Unique Payment ID
            let paymentID = randomstring.generate({
                length: 10,
                charset: 'alphanumeric',
                capitalization: 'uppercase'
            });
            await this.setState({
                pmtPaymentID : this.state.pmtOrderNumber + "" + paymentID, 
                modalPaymentProcessingMessage : 'Payment ID:'+paymentID,
                pmtCCNo : "",
                pmtFxCode : this.state.cartItems.items[0].currency // Get the first line currency code
            });

            let dataToProcess : any= {};
            dataToProcess.pmtID = this.state.pmtPaymentID;
            dataToProcess.orderNo = this.state.pmtOrderNumber;
            dataToProcess.amt = this.state.cartItems?.totAmt.toFixed(2);
            dataToProcess.fxCode = this.state.pmtFxCode;
            dataToProcess.ccNo = this.state.pmtCCNo;

            var userCart = {...this.state.cartItems}
            userCart.orderNo = this.state.pmtOrderNumber;   // order number is actually payment number
            userCart.pmtInfo = {
                pmtMethod: this.state.paymentMethod,
                pmtStatus: "Processing"
            };
            userCart.billingInfo= {
                name: this.state.billingName,
                address: this.state.billingAddr,
                phoneNo: this.state.billingPhoneNo,
                email: this.state.billingEmail,
            }

            dataToProcess.userCart = userCart;
            
            await this.setState({modalPaymentProcessingMessage : 'Preparing payment'});
            let pmtResponseData = await generalUtil.PrePaymentProcess(dataToProcess);
            if (pmtResponseData.isSuccess){
                await this.setState({ 
                    pmtClientIPAdd : pmtResponseData.IPAddress,
                    pmtHashValue : pmtResponseData.hashedValue,
                    modalPaymentProcessingMessage : 'IP:'+pmtResponseData.IPAddress
                });
                
                // Post to Payment gateway for processing
                
                await this.setState({modalPaymentProcessingMessage : 'Redirecting to Payment gateway...'});
                this.sleep(3000).then(
                (v) => {
                    this.setState({modalPaymentProcessingMessage : 'Redirecting...'});
                    
                    this.myFormRef.current.submit();
                });
            } else {
                store.addNotification({
                    title: "Info",
                    message: "Failed to process payment!",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
            }
            // console.log(pmtResponseData);
            // console.log(pmtResponseData.IPAddress);
            // console.log(pmtResponseData.hashKey);
            // console.log(pmtResponseData.hashedValue);
            // console.log(newOrderNo);
            // alert(newOrderNo);
            
            //document.getElementById("PaymentForm").
            //event.target.submit();
            //document.getElementById('PaymentForm').submit();

            //this.refs['form'].submit();
        }
    
    }

    sleep = (milliseconds:number) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    // handlePaymentClick = async (event: any) => {
    //     let getLatestOrderNumber = await generalUtil.GetLatestOrderNumber();

    //     let _cartItems: any = {
    //         items: [],
    //         subTot: 0.00,
    //         tax: 0.00,
    //         totAmt: 0.00,
    //         billingInfo: {
    //             name: this.state.billingName,
    //             address: this.state.billingAddr,
    //             phoneNo: this.state.billingPhoneNo,
    //             email: this.state.billingEmail,
    //         },
    //         pmtInfo: {
    //             pmtMethod: this.state.paymentMethod,
    //             pmtStatus: "Pending"
    //         }
    //     }

    //     let newOrderNo = 'S' + this.fixedNumberLen(getLatestOrderNumber.latestOrderNo, 5);
    //     let kw = this.props.user?.fullName + ' ' + this.props.user?.id + ' ' + newOrderNo + ' ';

    //     if (this.state.cartItems.items.length){
    //         this.state.cartItems.items.map((item: any) => {
    //             kw += item.courseId + ' ' + item.refNo + ' ';
    //         })
    //     }

    //     let _orderItem: any = {
    //         date: new Date(),
    //         orderNo: newOrderNo,
    //         userName: this.props.user?.fullName,
    //         oId: this.props.user?.id,
    //         noOfCourses: this.state.cartItems.items.length,
    //         cartItems: {
    //             items: this.state.cartItems.items,
    //             subTot: this.state.cartItems.subTot,
    //             tax: this.state.cartItems.tax,
    //             totAmt: this.state.cartItems?.totAmt,
    //             billingInfo: {
    //                 name: this.state.billingName,
    //                 address: this.state.billingAddr,
    //                 phoneNo: this.state.billingPhoneNo,
    //                 email: this.state.billingEmail,
    //             },
    //             pmtInfo: {
    //                 pmtMethod: this.state.paymentMethod,
    //                 pmtStatus: "Approved"
    //             }
    //         },
    //         isInvoiceGenerated: false,
    //         invoiceGeneratedOn: new Date(),
    //         searchKeywords : kw
    //     }

    //     this.setState({
    //         cartItems: _cartItems
    //     }, () => {
    //         // console.log(this.state.cartItems);
    //         // console.log(_orderItem);

    //         this.props.UpdateUserProfile({
    //             cart: this.state.cartItems
    //         });
    //         this.props.createRequest(_orderItem);
    //     });        
    // }

    handleDiscountChange(e:any) {
        this.setState({discountCode: e.target.value});
    }
    
    handleGetDiscountPopup(){
        this.setState({modalGetDiscount : !this.state.modalGetDiscount});
    }

    handleDiscount(){

        // Add Country, OrganiserName, and Profession 
        let itemInfo = this.state.cartItems.items.filter((d:any) => {
            return d.courseId === this.state.discountCourseId;   });

        //========================================
        // Client side validation
        //========================================
        // Find if any cart item already use this promo code, if yes 
        let promoInfo = this.state.cartItems.items.filter((d:any) => {
            return d.priceType === "Promo" && d.discountCode === this.state.discountCode ;  });
        console.log(promoInfo);
        // Check whether can only use for 1 time only per user
        if (promoInfo.length > 0){
            // Check number of time allow to use
            let totalTimesUsedForSamePromoCode = promoInfo.length;
            let TimeAllowed = promoInfo[0].promoRuleLimitUse;
            if (totalTimesUsedForSamePromoCode >= TimeAllowed){
                store.addNotification({
                    title: "Info",
                    message: "Discount code cannot use more than " + TimeAllowed + " time(s)",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
                return;
            }

            let onlyForSingleUsePerUser = promoInfo[0].promoRuleSingleUserPerUser;
            if (onlyForSingleUsePerUser){
                store.addNotification({
                    title: "Info",
                    message: "Discount code cannot use more for 1 time per user",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                });
                return;
            }
        }

        let doc : any = {};
        //console.log(itemInfo[0]);
        doc.courseId = this.state.discountCourseId;
        doc.coursePrice = this.state.discountCoursePrice;
        doc.discountCode = this.state.discountCode;
        doc.oId = this.props.user?.id;
        doc.professionList = itemInfo.length > 0 ? itemInfo[0].professionList : [];
        doc.countryList = itemInfo.length > 0 ? itemInfo[0].countryList: [];
        doc.organisersName = itemInfo.length > 0 ? itemInfo[0].organisersName: [];
        //console.log(doc);
        this.props.getDiscountRequest(doc);
    }

    handleDiscountClick = (event:any)=> {
        //console.log(event.target.getAttribute("data-coursePrice"));
        this.setState(
            {discountCourseId: event.target.id,
            discountCoursePrice : event.target.getAttribute("data-coursePrice")
            }, () => {
            this.handleGetDiscountPopup();
        });
        //alert(event.target.id);
        //alert(this.state.discountCode);
    }

    handleModalPaymentResultMessage(){
        this.setState({modalPaymentResultPopupState : !this.state.modalPaymentResultPopupState});
    }

   
    public render() {
        const closeBtn = <button className="close" onClick={this.handleGetDiscountPopup}>&times;</button>;
        
        if (this.state.redirect){
            return <Redirect to="/mycourses" />
        }

        const cartItemsByOrganiser = this.state.cartItems?.items?.reduce(function (r:any, a:any) {
            r[a.organisersName] = r[a.organisersName] || [];
            r[a.organisersName].push(a);
            return r;
        }, Object.create(null));
        
        // const items:any = [];
        // Object.keys(cartItemsByOrganiser).forEach(function(key) {
        //     cartItemsByOrganiser[key].forEach(function(item:any){
        //         //console.log(item.title);
        //         items.push(<ListGroupItem>
        //                  <Row>
        //                      <Col lg={3}>
        //                          <span>{item.title}</span>
        //                      </Col>
        //                  </Row>
        //              </ListGroupItem>);
        //     });
        // })

        return (        
            <Container>
                <Row>
                    <Col lg={9}>
                        <ListGroup>
                            <ListGroupItem>
                                <ListGroupItemHeading>{(this.state?.cartItems?.items?.length) ?? 0} item(s)</ListGroupItemHeading>
                            </ListGroupItem>
                            {
                                cartItemsByOrganiser != null && Object.keys(cartItemsByOrganiser).map((key:any, i:any) => 
                                    <div>
                                        <ListGroupItem style={{backgroundColor:"WhiteSmoke"}}>
                                            <Row>
                                                <Col lg={12}>
                                                    <span style={{fontWeight:"bold"}}>{key}</span>
                                                </Col>
                                            </Row>
                                        </ListGroupItem>
                                        {
                                            cartItemsByOrganiser[key].map((item:any, j:any) =>
                                            <ListGroupItem>
                                            <Row>
                                                <Col lg={3}>
                                                    <img 
                                                        src={(item.courseImg) ? this.GetImagePath(item.courseImg) : "/images/empty-100.png"}
                                                        alt="" 
                                                        width={180} 
                                                    />
                                                </Col>
                                                <Col lg={7}>
                                                    <Row>
                                                        <a href={"/#/courses/" + item.courseId}>{item.title}</a>
                                                    </Row>
                                                    <Row>
                                                        Reference Number: {item.refNo}
                                                    </Row>
                                                    <Row>
                                                        Credit Hours/Points: {this.constructCPDPoint(item.cpdPoints)}
                                                    </Row>
                                                    {/* <Row style={{textAlign: "justify"}}>
                                                        Description: {item.shortDesc}
                                                    </Row> */}
                                                    <Row>
                                                        Organiser: {item.organisersName}
                                                    </Row>
                                                    <Row>
                                                        { (item.verificationType == "noVerification") &&
                                                            <div style={{backgroundColor: "#E8E8E8", padding: "5px", borderRadius:"10px"}}>
                                                                <img width='36px' src='data:image/svg+xml;base64,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' />
                                                                Face Recognition Not Required to complete the course
                                                            </div>
                                                        }
                                                        
                                                        { (item.verificationType == "Verification") &&
                                                            <div style={{backgroundColor: "#E8E8E8", padding: "5px", borderRadius:"10px"}}>
                                                                <img width='36px' src='data:image/svg+xml;base64,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' />    
                                                                Face Recognition Required to complete the course
                                                            </div>
                                                        }
                                                    </Row>
                                                    {/* <Row>
                                                        <Col lg={6}>
                                                        <Input type="text" name="discountCode"
                                                            placeholder="Enter Discount Code"
                                                            onChange={this.handleDiscountChange(index)}
                                                            value={this.state.discountList[index]} ></Input>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <Button color="warning" name="discount" id={item.courseId} onClick={this.handleDiscount} >Apply</Button>
                                                        </Col>
                                                    </Row> */}
                                                </Col>
                                                <Col lg={2}>
                                                    <div style={{textAlign:"right", fontSize:"smaller"}}>
                                                        {(item.priceType === "Discount" || item.priceType === "Promo") ?
                                                            <Badge color="danger">
                                                                &nbsp;&nbsp;{item.priceType}&nbsp;&nbsp;
                                                            </Badge> : 
                                                        item.priceType === "Member" ?
                                                            <Badge color="primary">
                                                            &nbsp;&nbsp;{item.priceType}&nbsp;&nbsp;
                                                            </Badge>:
                                                            <Badge>
                                                            &nbsp;&nbsp;{item.priceType}&nbsp;&nbsp;
                                                            </Badge>
                                                        }
                                                    </div>
                                                    <div style={{float: "right", fontSize:"larger", fontWeight:"bold"}}>
                                                        {item.currency == null ? "RM" : item.currency} {(item?.price??0).toFixed(2)}
                                                    </div>
                                                    <div style={{float: "right"}}>
                                                        <Col lg={6} style={{textAlign:"center"}}>
                                                            <Button size="sm" color="warning" name="discount" 
                                                                hidden={(item.priceType === "Discount" || item.priceType === "Promo")}
                                                                id={item.courseId} data-coursePrice={item.price} onClick={this.handleDiscountClick} >
                                                                Discount Code
                                                            </Button>
                                                            {
                                                                (item.priceType === "Discount" || item.priceType === "Promo") && <Label style={{fontSize:"smaller", textAlign:"center"}}>Code:{item.discountCode}</Label>
                                                            }
                                                        </Col>
                                                    </div>
                                                    <div style={{position: "absolute", bottom: 0, right: "15px"}}>
                                                        <i className="fas fa-trash" title="Remove" id={item.courseId} onClick={this.handleRemoveFromCart} style={{cursor: "pointer"}} ></i>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </ListGroupItem>
                                        )
                                        }
                                    </div>
                                )
                            }
                            
                            {/* {items} */}
                            {/* { JSON.stringify(cartItemsByOrganiser) } */}
                            {
                                
                                // cartItemsByOrganiser.map((item: any, index:number) =>
                                //     <ListGroupItem>
                                //         <Row>
                                //              <Col lg={3}>
                                //                 <span>{item}</span>
                                //             </Col>
                                //         </Row>
                                //     </ListGroupItem>
                                // )
                            }
                        </ListGroup>
                    </Col>
                    <Col lg={3}> 
                        <ListGroup>
                            <ListGroupItemHeading>Order Summary</ListGroupItemHeading>
                            <ListGroupItem>
                                {/* <FormGroup row={true}>
                                    <Label for="" lg={12}>Sub-Total</Label >
                                    <Col lg={12}>
                                        <Input type="text" name=""
                                            value={"RM " + ((this.state.cartItems?.subTot?.toFixed(2))?.toString() ?? "0.00")}
                                            style={{textAlign: "right"}}
                                            readOnly
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="" lg={12}>Tax</Label >
                                    <Col lg={12}>
                                        <Input type="text" name=""
                                            value={"RM " + ((this.state.cartItems?.tax?.toFixed(2))?.toString() ?? "0.00")}
                                            style={{textAlign: "right"}}
                                            readOnly
                                        />
                                    </Col>
                                </FormGroup> */}
                                <FormGroup row={true}>
                                    <Label for="" lg={12}>Total</Label >
                                    <Col lg={12}>
                                        <Input type="text" name=""
                                            value={((this.state.cartItems?.totAmt?.toFixed(2))?.toString() ?? "0.00")}
                                            style={{textAlign: "right", fontSize:"large", fontWeight:"bold" }}
                                            readOnly
                                        />
                                    </Col>
                                    <Col lg={12}>&nbsp;
                                    </Col>
                                    <Col lg={12}>
                                        <Button color="primary" name="payment" disabled={(!(this.state.cartItems?.items?.length > 0 && this.state.billingName && this.state.billingAddr && this.state.billingPhoneNo && this.state.billingEmail) ?? true) || this.props.user.processing }
                                            onClick={this.handlePaymentSubmit} 
                                            style={{float: "right"}} block
                                        >Make Payment</Button>
                                    </Col>
                                </FormGroup>
                            </ListGroupItem>
                        </ListGroup>
                        <br />
                        <ListGroup>
                            <ListGroupItemHeading>Billing Information</ListGroupItemHeading>
                            <ListGroupItem>
                                <FormGroup row={true}>
                                    <Label for="" lg={12}>Name</Label >
                                    <Col lg={12}>
                                        <Input type="text" name="billingName" 
                                            onChange={this.handleInputOnChange} 
                                            value={this.state.billingName}
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="" lg={12}>Address Type</Label >
                                    <Col lg={12}>
                                        <Select 
                                            name="address"
                                            options={_addrSelection}
                                            onChange={this.handleSelectOnChange}
                                            defaultValue={this.handleSelectedOption(_addrSelection, "Home")}
                                        />
                                    </Col>
                                </FormGroup>
                                {
                                    (this.state.addrType !== "") && (
                                        <FormGroup row={true}>
                                            <Label for="" lg={12}>{this.state.addrType.label}</Label >
                                            <Col lg={12}>
                                                <Input type="textarea" name="billingAddr" 
                                                    onChange={this.handleInputOnChange} 
                                                    value={this.state.billingAddr} 
                                                    rows={5} style={{width: "100%"}} 
                                                />
                                            </Col>
                                        </FormGroup>
                                    )
                                }
                                <FormGroup row={true}>
                                    <Label for="" lg={12}>Contact Number</Label >
                                    <Col lg={12}>
                                        <Input type="text" name="billingPhoneNo" 
                                            onChange={this.handleInputOnChange}
                                            value={this.state.billingPhoneNo} 
                                        />
                                    </Col>
                                </FormGroup>
                                <FormGroup row={true}>
                                    <Label for="" lg={12}>Email</Label >
                                    <Col lg={12}>
                                        <Input type="text" name="billingEmail" 
                                            onChange={this.handleInputOnChange}
                                            value={this.state.billingEmail} 
                                        />
                                    </Col>
                                </FormGroup>
                            </ListGroupItem>
                        </ListGroup>
                        <br />
                       
                        {
                            this.props.user.processing && (<Spinner color="warning" className="float-right">&nbsp;</Spinner>)
                        }  
                        {/* <Button color="primary" name="payment" disabled={(!(this.state.billingName && this.state.billingAddr && this.state.billingPhoneNo && this.state.billingEmail) ?? true) || this.props.user.processing }
                            onClick={this.handlePaymentClick} 
                            style={{float: "right"}}
                        >Make Payment</Button> */}
                         
                        {/* <Form id="PaymentForm" action="https://test2pay.ghl.com/IPGSG/Payment.aspx" onSubmit={this.handlePaymentSubmit}>
                            <Input name="ServiceID" type="text" value="sit"/>
                            <Input name="PaymentID" type="text" value={this.state.pmtOrderNumber} />

                            <Button color="primary" name="payment" disabled={(!(this.state.billingName && this.state.billingAddr && this.state.billingPhoneNo && this.state.billingEmail) ?? true) || this.props.user.processing }
                                //onClick={this.handlePaymentClick} 
                                type="submit"
                                style={{float: "right"}}
                            >Make Payment</Button>
                        </Form> */}
                    </Col>
                </Row>
                <br/>
                <Modal isOpen={this.state.modalGetDiscount} toggle={this.handleGetDiscountPopup}>
                    <ModalHeader toggle={this.handleGetDiscountPopup} close={closeBtn}>
                        Validate Discount (Course:{this.state.discountCourseId})
                    </ModalHeader>
                    <ModalBody>
                        <div className="card p-2 mt-3">
                            <div className="input-group">
                                <input type="text" className="form-control" placeholder="Please enter discount code here..." 
                                    disabled={this.props.cart.processing}
                                    onChange={this.handleDiscountChange} />
                                <div className="input-group-append">
                                    <Button type="submit" color="primary" onClick={this.handleDiscount} disabled={this.props.cart.processing}>
                                        <i className="fas fa-check mr-1"></i>&nbsp;Redeem
                                    </Button>
                                </div>
                            </div>
                            <br />
                            <Alert color="success" isOpen={this.props.cart.processState === 1}>
                                Discount added!
                            </Alert>
                            <Alert color="danger" isOpen={this.props.cart.processState === 2}>
                                {this.props.cart.errors??"Invalid Discount Code. Unidentified error!"}
                            </Alert> 
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Spinner color="warning" hidden={!this.props.cart.processing} />
                        {/* <Link className="btn btn-primary float-left" hidden={ (this.props.ui.addState === 1) ? false : true } to="/mycourses">Go to My Course</Link> */}
                        <Button color="secondary" onClick={this.handleGetDiscountPopup} disabled={this.props.cart.processing}>Close</Button>
                    </ModalFooter>
                </Modal>
                <br /><br /><br /><br /><br /><br /><br />
                <form id="PaymentForm" action="https://securepay.e-ghl.com/IPG/Payment.aspx" ref={this.myFormRef}>
                    <input name="TransactionType" type="hidden" value="SALE"/>
                    {/* <input name="PymtMethod" type="hidden" value="ANY"/> */}
                    <input name="PymtMethod" type="hidden" value="ANY"/>
                    <input name="ServiceID" type="hidden" value="ULP"/>
                    <input name="PaymentID" type="hidden" value={this.state.pmtPaymentID} />
                    <input name="OrderNumber" type="hidden" value={this.state.pmtOrderNumber} />
                    <input name="PaymentDesc" type="hidden" value={"Payment number " + this.state.pmtOrderNumber}/>
                    <input name="MerchantName" type="hidden" value="UltimatesPro"/>
                    <input name="MerchantReturnURL" type="hidden" value="https://ultimatesprodevapi02.azurewebsites.net/api/PaymentResponse"/>
                    <input name="MerchantCallbackURL" type="hidden" value="https://ultimatesprodevapi02.azurewebsites.net/api/PaymentResponseServer"/>
                    <input name="Amount" type="hidden" value={this.state.cartItems?.totAmt ? this.state.cartItems?.totAmt.toFixed(2) : "0.00"} />
                    <input name="CurrencyCode" type="hidden" value={this.state.pmtFxCode}/>
                    <input name="CustIP" type="hidden" value={this.state.pmtClientIPAdd}/>
                    <input name="CustName" type="hidden" value={this.props.user?.fullName}/>
                    <input name="CustEmail" type="hidden" value={this.state.billingEmail} />
                    <input name="CustPhone" type="hidden" value={this.state.billingPhoneNo} />
                    <input name="HashValue" type="hidden" value={this.state.pmtHashValue} />
                    <input name="MerchantTermsURL" type="hidden" value="https://ultimatespro.com/#/terms-of-use"/>
                    <input name="LanguageCode" type="hidden" value="en"/>
                    <input name="PageTimeout" type="hidden" value="900"/>
                    {/* <input name="CardHolder" type="hidden" value="My Name"/>
                    <input name="CardNo" type="hidden" value={this.state.pmtCCNo}/>
                    <input name="CardExp" type="hidden" value="202212"/>
                    <input name="CardCVV2" type="hidden" value="123"/> */}
                    <input name="CardHolder" type="hidden" value=""/>
                    <input name="CardNo" type="hidden" value=""/>
                    <input name="CardExp" type="hidden" value=""/>
                    <input name="CardCVV2" type="hidden" value=""/>
                </form>
                <Modal size="md" isOpen={this.state.modalPaymentProcessingPopupState} unmountOnClose={false}>
                    <ModalHeader><i className="fas fa-cog mr-1"></i>Payment Processing</ModalHeader>
                    <ModalBody>
                        <Label>Redirecting to third party payment gateway.</Label><br/><br/>
                        <Label>Payment ID : {this.state.pmtPaymentID}</Label><br/>
                        <Label>Payment No : {this.state.pmtOrderNumber}</Label><br/><br/>
                    </ModalBody>
                    <ModalFooter>
                        <Label>State : </Label>
                        <Label style={{fontWeight:"bolder"}}>{this.state.modalPaymentProcessingMessage}&nbsp;&nbsp;<Spinner color="primary" size="sm"/></Label><br/><br/>
                    </ModalFooter>
                </Modal>
                <Modal size="md" isOpen={this.state.modalPaymentResultPopupState} unmountOnClose={true}>
                    <ModalHeader toggle={this.handleModalPaymentResultMessage}><i className="fas fa-exclamation-triangle mr-1" style={{color:"#8b0000"}}></i>Payment Failed</ModalHeader>
                    <ModalBody>
                        <Label>Payment failed with following error:</Label><br/>
                        <Label style={{fontWeight:"bolder"}}>{this.state.modalPaymentResultMessage}</Label><br/><br/>
                        <Label>Please try to make payment again.</Label>
                    </ModalBody>
                    <ModalFooter>
                        {/* <Button color="primary" onClick={this.handleSendAskTrainer}>Send</Button>{' '} */}
                        <Button color="secondary" onClick={this.handleModalPaymentResultMessage}>Okay</Button>
                    </ModalFooter>
                </Modal>
            </Container>
        )
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    //user: state.userReducer
    userRd: state.userReducer ,
    user: state.userInfo.byId[0],
    cart : state.cart.ui
})

const mapDispatchToProps = {
    UpdateUserProfile: UpdateUserProfileAction,
    verified: verifiedAction,
    fetchUserRequest: getUserAction,
    createRequest : createRequestAction,
    getDiscountRequest : getDiscountRequestAction
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ShopingCart)
